import { jsx as e } from "react/jsx-runtime";
import { getIconStyles as l } from "../styles.js";
const t = (o) => /* @__PURE__ */ e(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: l(o),
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.80054 12.0117L18.0097 22.2208C18.4002 22.6114 18.4002 23.2445 18.0097 23.635C17.6191 24.0256 16.986 24.0256 16.5955 23.635L6.20993 13.2495C6.04749 13.0872 5.91811 12.8939 5.83015 12.6818C5.7421 12.4694 5.69678 12.2418 5.69678 12.0119C5.69678 11.782 5.7421 11.5544 5.83015 11.342C5.91806 11.13 6.04685 10.9374 6.20916 10.7751L6.20993 10.7743L16.5946 0.365785C16.9847 -0.025186 17.6179 -0.0259107 18.0089 0.364166C18.3998 0.754243 18.4006 1.38741 18.0105 1.77838L7.80054 12.0117Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  t as ChevronLeftIcon
};
//# sourceMappingURL=ChevronLeftIcon.js.map
